import { createContext, useContext, useState } from "react";

const ToastContext = createContext();

const ToastProvider = ({ children }) => {
  const [mainMessage, setMainMessage] = useState();
  const [licenceInfo, setLicenceInfo] = useState();
  const [localUserSearch, setLocalUserSearch] = useState("");
  const [appRegions, setAppRegions] = useState([]);
  const [appNames, setAppNames] = useState([]);
  const [appTypes, setAppTypes] = useState([]);

  return (
    <ToastContext.Provider
      value={{
        mainMessage,
        setMainMessage,
        licenceInfo,
        setLicenceInfo,
        localUserSearch,
        setLocalUserSearch,
        appNames,
        setAppNames,
        appRegions,
        setAppRegions,
        appTypes,
        setAppTypes,
      }}
    >
      {children}
    </ToastContext.Provider>
  );
};

const UseToast = () => useContext(ToastContext);

export { UseToast, ToastProvider };
